const experimentConfig = {
  globalExperiment: {
    experimentId: 'Q4KMAh3BQ4qNUNsdMXdprg',
    running: true,
    loadingCover: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false,
        homepageNewDesign: false
      },
      1: {
        globalExperiment: true,
        homepageNewDesign: true,
        categoryPageBlocksB: true
      }
    }
  },
  newHomepageExperimentNoVariation: {
    experimentId: 'eCQGElkrSVqkXjHjD14dBg',
    running: true,
    sites: [
      'themeforest',
      'codecanyon',
      'graphicriver',
      'photodune',
      '3docean'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: true
      },
      1: {
        homepageNewDesign: true
      }
    }
  },
  newHomepageExperiment: {
    experimentId: 'eCQGElkrSVqkXjHjD14dBg',
    running: true,
    sites: ['videohive', 'audiojungle'],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: false
      },
      1: {
        homepageNewDesign: true
      }
    }
  },
  csatSurveyExperiment: {
    experimentId: 'csat_survey',
    running: false,
    sites: [
      'themeforest',
      'codecanyon',
      'videohive',
      'graphicriver',
      'audiojungle'
    ],
    loadingCover: false,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variantsWeights: [9, 1],
    variants: {
      0: {
        canShowCSATSurvey: false
      },
      1: {
        canShowCSATSurvey: true
      }
    }
  },
  itemCardTagsExperiment: {
    experimentId: 'KPjrVT2lTZ6xjZWU2O4gng',
    running: true,
    sites: [
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {}
    }
  },
  itemCardTagsRemoval: {
    experimentId: 'KPjrVT2lTZ6xjZWU2O4gng',
    running: true,
    sites: ['themeforest'],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        shouldRemoveTags: false
      },
      1: {
        shouldRemoveTags: true
      }
    }
  },
  homePageCopyUpdates: {
    experimentId: '38IZ2heHTeyVuJ9OGcqDnA',
    running: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        ogCopyVerbatim: false,
        combinedCopyNoDollars: false,
        combinedCopyWithDollars: false
      },
      1: {
        ogCopyVerbatim: true,
        combinedCopyNoDollars: false,
        combinedCopyWithDollars: false
      },
      2: {
        ogCopyVerbatim: true,
        combinedCopyNoDollars: true,
        combinedCopyWithDollars: false
      },
      3: {
        ogCopyVerbatim: false,
        combinedCopyNoDollars: false,
        combinedCopyWithDollars: true
      }
    }
  },
  homePageImages: {
    experimentId: 'BywMU63lQI-pjhgnfw3zyw',
    running: false,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        newHomeHeaderImages: false,
        homeHeaderCopyOnly: false
      },
      1: {
        newHomeHeaderImages: true,
        homeHeaderCopyOnly: false
      },
      2: {
        newHomeHeaderImages: false,
        homeHeaderCopyOnly: true
      }
    }
  },
  updatedCategoryNav: {
    experimentId: 'fFuj2cGCQrS374O9TUL8rw',
    running: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        hideCategoryNavLinks: false,
        compressedCategoryNav: false,
        hideCategoryNavIcons: false,
        hideCategoryNavCopy: false,
        gridViewCategoryNav: false
      },
      1: {
        hideCategoryNavLinks: true,
        compressedCategoryNav: false,
        hideCategoryNavIcons: false,
        hideCategoryNavCopy: false,
        gridViewCategoryNav: false
      },
      2: {
        hideCategoryNavLinks: true,
        compressedCategoryNav: true,
        hideCategoryNavIcons: false,
        hideCategoryNavCopy: false,
        gridViewCategoryNav: false
      },
      3: {
        hideCategoryNavLinks: true,
        compressedCategoryNav: true,
        hideCategoryNavIcons: true,
        hideCategoryNavCopy: false,
        gridViewCategoryNav: false
      },
      4: {
        hideCategoryNavLinks: true,
        compressedCategoryNav: true,
        hideCategoryNavIcons: true,
        hideCategoryNavCopy: true,
        gridViewCategoryNav: false
      },
      5: {
        hideCategoryNavLinks: false,
        compressedCategoryNav: false,
        hideCategoryNavIcons: false,
        hideCategoryNavCopy: false,
        gridViewCategoryNav: true
      }
    }
  }
}

export default experimentConfig
